import { useEffect, useState } from "react";

import { useBlogSelectors } from "../store/blog/blog.selectors";

import { useDispatchedActions } from "./use-dispatch-actions";
import { useQueryData } from "./useQueryData";

export const useGetBlogContent = () => {
  const [isMounted, setIsMounted] = useState(false);

  const { params, languageCode, page, tab } = useQueryData();

  const { getBlogContent, getBlogFacts } = useDispatchedActions();
  const { isBlogDataLoaded, blogLanguage } = useBlogSelectors();

  useEffect(() => {
    if (!blogLanguage) {
      getBlogFacts(languageCode);
    } else if (blogLanguage !== languageCode) {
      getBlogFacts(languageCode);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [languageCode, blogLanguage]);

  useEffect(() => {
    if (!isBlogDataLoaded) {
      getBlogContent(params);
    }
  }, [isBlogDataLoaded]);

  useEffect(() => {
    if (isMounted) {
      getBlogContent(params);
    } else {
      setIsMounted(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [languageCode, page, tab]);
};
